import React from "react";
import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import { useAvatarImage } from "@coworker/app/src/hooks/API/avatar.service";
import styles from "./avatar.module.css";

interface AvatarProps {
  isBigImage: boolean;
  uid: string;
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({
  isBigImage,
  uid,
  className = "",
}) => {
  const avatarUrl = useAvatarImage(uid);
  return (
    <div className={className}>
      <FixaImage
        className={
          (isBigImage ? styles["big-image"] : styles["small-image"]) as string
        }
        src={avatarUrl}
      />
    </div>
  );
};
